// 大屏
export default [
  {
    path: '/screen/index',
    name: 'PageScreen',
    component: () =>
      import(
        /* webpackChunkName: "datascreen" */ '../pages/datascreen/PageScreen'
      ),
    meta: { modular: 7, title: '数据大屏', info: '数据大屏——首页' }
  },
  {
    path: '/screen/help',
    name: 'PageScreenHelp',
    component: () =>
      import(
        /* webpackChunkName: "datascreen" */ '../pages/datascreen/PageScreenHelp'
      ),
    meta: { modular: 7, title: '如何投屏', info: '数据大屏——如何投屏' }
  },
  {
    path: '/screen/error',
    name: 'PageScreenError',
    component: () =>
      import(
        /* webpackChunkName: "datascreen" */ '../pages/datascreen/PageScreenError'
      ),
    meta: { modular: 7, title: '错误提示', info: '数据大屏——错误信息' }
  },
  {
    path: '/screen/detail',
    name: 'PageScreenDetail',
    component: () =>
      import(
        /* webpackChunkName: "datascreen" */ '../pages/datascreen/PageScreenDetail'
      ),
    meta: { modular: 7, title: '数据大屏', info: '数据大屏——详情' }
  },
  {
    path: '/screen/select',
    name: 'PageScreenSelect',
    component: () =>
      import(
        /* webpackChunkName: "datascreen" */ '../pages/datascreen/PageScreenSelect'
      ),
    meta: { modular: 7, title: '选择大屏', info: '数据大屏——选择大屏' }
  },
  {
    path: '/screen/selectClass',
    name: 'PageScreenSelectClass',
    component: () =>
      import(
        /* webpackChunkName: "datascreen" */ '../pages/datascreen/PageScreenSelectClass'
      ),
    meta: { modular: 7, title: '选择班级', info: '数据大屏——选择班级' }
  },
  {
    path: '/screen/headmaster',
    name: 'PageScreenHeadmaster',
    component: () =>
      import(
        /* webpackChunkName: "datascreen" */ '../pages/datascreen/PageScreenHeadmaster'
      ),
    meta: {
      modular: 7,
      title: '数据大屏',
      info: '数据大屏——班主任投屏列表'
    }
  }
]
